var map = {
	"./b0.png": "b286",
	"./b1.png": "c3d9",
	"./b2.png": "ae10",
	"./b3.png": "441d",
	"./b4.png": "532b",
	"./b5.png": "0257",
	"./b6.png": "bbb2",
	"./b7.png": "c3ac",
	"./btn1.png": "c986",
	"./btn2.png": "18d4",
	"./btn3.png": "dd61"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6b6a";